import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as deviceService from '../services/devices';

const initialState = {
  device: null,
  isFetching: false,
  fetchingError: null,
};

const sliceName = 'devices';

export const fetchByKey = createAsyncThunk(
  `${sliceName}/fetchByKey`,
  (args, thunkAPI) => {
    return deviceService
      .getDeviceByKey(args.deviceKey)
      .catch((error) => {
        error.clientMessage = "Can't get device by key from server";
        return thunkAPI.rejectWithValue(error)
      });
  }
);

const devices = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchByKey.fulfilled]: (state, action) => {
      state.isFetching = false;
      state.device = action.payload;
    },
    [fetchByKey.pending]: (state) => {
      state.isFetching = true;
      state.fetchingError = null;
    },
    [fetchByKey.rejected]: (state, action) => {
      state.isFetching = false;
      state.fetchingError = action.payload;
    },
  }
})

const { reducer } = devices;

export const devicesSelectors = {
  loadedDevice: (state) => state[sliceName].device,

  isFetching: (state) => state[sliceName].isFetching,
  fetchingError: (state) => state[sliceName].fetchingError,
}

export default reducer;


// WEBPACK FOOTER //
// ./src/store/devicesSlice.js